module.exports = __webpack_public_path__ + "static/media/grafico-unicred-centro-sul-1.62623501.png";